// drawOla cloud storage — provider-agnostic error classes.
//
// Providers translate their wire-level errors (HTTP 401/404/412, network
// failure) into these classes so callers can branch without knowing about
// Drive / Dropbox / OneDrive specifics.

export class TokenExpiredError extends Error {
  constructor() {
    super("Cloud token expired");
    this.name = "TokenExpiredError";
  }
}

export class ConflictError extends Error {
  public readonly remoteVersion: string;
  constructor(remoteVersion: string) {
    super("Cloud file modified remotely");
    this.name = "ConflictError";
    this.remoteVersion = remoteVersion;
  }
}

export class NetworkError extends Error {
  constructor(cause?: unknown) {
    super("Network error");
    this.name = "NetworkError";
    if (cause !== undefined) {
      (this as any).cause = cause;
    }
  }
}

export class NotFoundError extends Error {
  constructor() {
    super("Cloud file not found");
    this.name = "NotFoundError";
  }
}
